import React from 'react';
import styled from 'styled-components';
import { FooterNavigationItems } from './FooterNavigationItems';
import { Accordion, AccordionPanel, AccordionToggleButton } from '../Accordion';
const Container = styled.nav `
  .accordion-heading {
    color: ${({ theme }) => theme.trueBlack};
  }
  .toggle-button {
    min-height: 70px;
    padding: 0;
  }
`;
export const MobileFooterNavigation = ({ footerItems }) => {
    if (!footerItems)
        return null;
    const navSection = footerItems.find((item) => item.displayName === 'NavigationSection');
    const navItems = navSection && navSection.fields && navSection.fields.items;
    const NavItems = ({ items }) => {
        return (React.createElement(Accordion, { data: items, initialOpenPanels: [0], render: ({ isPanelOpen, togglePanel, data }) => {
                return (React.createElement(React.Fragment, null, data.map(({ fields }, index) => {
                    const { categoryTitle, items } = fields;
                    return (React.createElement(AccordionPanel, { key: index, isOpen: isPanelOpen(index), onToggle: () => togglePanel(index), renderToggleButtonAs: ({ isOpen, onToggle }) => (React.createElement(AccordionToggleButton, { isOpen: isOpen, onToggle: onToggle, heading: categoryTitle && categoryTitle.value, withLabel: categoryTitle, showDownArrow: true })) },
                        React.createElement(FooterNavigationItems, { items: items })));
                })));
            } }));
    };
    return (React.createElement(Container, null,
        React.createElement(NavItems, { items: navItems })));
};
